import { defineMessages } from 'react-intl';

export default defineMessages({
    billingMessage: {
        id: 'renewal.common.views.change-bound.billingMessage',
        defaultMessage: 'You can check the payment schedule and invoices here: ',
    }
});
